import React from 'react';
import { ExternalLink } from 'lucide-react';

const formatDetails = (lead) => {
  if (lead.type === 'seller') {
    return [lead.cityState, lead.propertyAddress, lead.details].filter(Boolean).join(' • ');
  }
  return [lead.companyName, lead.preferredMarkets, lead.buyBox].filter(Boolean).join(' • ');
};

const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : '—');

const LeadRow = ({ lead }) => (
  <tr data-testid={`lead-row-${lead.id}`} className="hover:bg-slate-50">
    <td className="px-4 py-3">
      <span
        className={`px-2 py-0.5 rounded-full text-xs font-medium ${
          lead.type === 'seller' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'
        }`}
      >
        {lead.type}
      </span>
    </td>
    <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{formatDate(lead.createdAt)}</td>
    <td className="px-4 py-3 font-medium text-slate-900">{lead.fullName || '—'}</td>
    <td className="px-4 py-3 text-slate-700">
      <a href={`mailto:${lead.email}`} className="hover:text-emerald-600">{lead.email}</a>
    </td>
    <td className="px-4 py-3 text-slate-700">
      {lead.phone ? <a href={`tel:${lead.phone}`} className="hover:text-emerald-600">{lead.phone}</a> : '—'}
    </td>
    <td className="px-4 py-3">
      <div className="flex items-center gap-1">
        <span className="font-mono text-xs px-2 py-0.5 bg-slate-100 rounded">{lead.source || 'home'}</span>
        {lead.sourceUrl && (
          <a href={lead.sourceUrl} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-emerald-600">
            <ExternalLink className="w-3 h-3" />
          </a>
        )}
      </div>
    </td>
    <td className="px-4 py-3 text-slate-600 max-w-xs truncate">{formatDetails(lead)}</td>
  </tr>
);

const LeadsTable = ({ rows }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
        <tr>
          <th className="px-4 py-3">Type</th>
          <th className="px-4 py-3">Created</th>
          <th className="px-4 py-3">Name</th>
          <th className="px-4 py-3">Email</th>
          <th className="px-4 py-3">Phone</th>
          <th className="px-4 py-3">Source</th>
          <th className="px-4 py-3">Details</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">
        {rows.map((lead) => (
          <LeadRow key={lead.id} lead={lead} />
        ))}
        {rows.length === 0 && (
          <tr>
            <td colSpan="7" className="px-4 py-12 text-center text-slate-500">
              No leads match your filters
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default LeadsTable;
